import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'th',
    fullName: 'Thai',
    nativeName: 'ไทย',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "อาร์กวอยด์",
    landing_title: "สิ่งมหัศจรรย์กำลังจะมา",
    landing_subtitle: "ArgVoid คือสตูดิโอพัฒนาแอปและเกม คอยติดตามสิ่งใหม่กำลังจะมาเร็ว ๆ นี้!",
    select_language: "เลือกภาษา",
    search_placeholder: "ค้นหาภาษา...",
    terms_title: "ข้อกำหนดในการให้บริการ",
    policy_title: "นโยบายความเป็นส่วนตัว",
    cookies_title: "นโยบายคุกกี้",
    terms_content: `
        <strong>1. การยอมรับข้อกำหนด </strong><br>
        เมื่อเข้าถึง ArgVoid ถือว่ายอมรับข้อกำหนดในการให้บริการเหล่านี้ หากไม่ตกลงเงื่อนไขเหล่านี้ไม่ควรใช้บริการ <br><br>

        <strong>2. การใช้งานแพลตฟอร์ม</strong><br>
        ArgVoid และแอปพลิเคชันต่างๆ จัดทำขึ้น "ตามสภาพ" เพื่อวัตถุประสงค์ในการให้ข้อมูลและการสร้างสรรค์ ต้องใช้บริการเพื่อวัตถุประสงค์ที่ถูกต้องตามกฎหมายเท่านั้น <br><br>

        <strong>3. พฤติกรรมต้องห้าม</strong><br>
        ห้ามมิให้ใช้ประโยชน์จากช่องโหว่ของไซต์ สแปม หรือพยายามเข้าถึงโครงสร้างพื้นฐานโดยไม่ได้รับอนุญาต <br><br>

        <strong>4. ข้อสงวนสิทธิ์</strong><br>
        แพลตฟอร์มและบริการอาจมีการปรับเปลี่ยนได้ตลอดเวลาโดยไม่ต้องแจ้งให้ทราบ ไม่มีการรับประกันเกี่ยวกับเวลาทำงานหรือความพร้อมใช้งานของบริการ
    `,
    policy_content: `
        <strong>1. การรวบรวมข้อมูล</strong><br>
        แพลตฟอร์มไม่ต้องการการรับรองความถูกต้องของผู้ใช้หรือการสร้างบัญชีในขณะนี้ ไม่มีการรวบรวมข้อมูลส่วนบุคคล (เช่น ชื่อหรือที่อยู่อีเมล) จากผู้เยี่ยมชม <br><br>

        <strong>2. ข้อมูลการใช้งาน</strong><br>
        การวิเคราะห์พื้นฐานที่ไม่เปิดเผยตัวตนอาจถูกรวบรวมเพื่อทำความเข้าใจการเข้าชมไซต์และปรับปรุงแอปพลิเคชัน ข้อมูลนี้ไม่ได้เชื่อมโยงกับข้อมูลระบุตัวตนผู้ใช้แต่ละราย <br><br>

        <strong>3. บริการของบุคคลที่สาม</strong><br>
        ผู้ให้บริการบุคคลที่สามอาจถูกใช้สำหรับบริการโฮสต์และการวิเคราะห์ แนวทางปฏิบัติด้านความเป็นส่วนตัวของผู้ให้บริการที่เกี่ยวข้องเหล่านี้จะควบคุมข้อมูลที่ไม่ระบุตัวตนที่ประมวลผลบนโครงสร้างพื้นฐานของตน <br><br>

        <strong>4. ความปลอดภัยของข้อมูล</strong><br>
        มีการนำมาตรการรักษาความปลอดภัยที่เหมาะสมมาใช้เพื่อปกป้องแพลตฟอร์ม อย่างไรก็ตาม ไม่มีวิธีการส่งข้อมูลทางอินเทอร์เน็ตใดที่ปลอดภัยโดยสิ้นเชิง <br><br>
    `,
    cookies_content: `
        <strong>1. คุกกี้และที่เก็บข้อมูลในเครื่องคืออะไร?</strong><br>
        คุกกี้และที่เก็บข้อมูลในเบราว์เซอร์เป็นไฟล์ข้อมูลขนาดเล็กที่จัดเก็บไว้ในอุปกรณ์เพื่อจดจำการตั้งค่าการกำหนดค่าระหว่างการเข้าชม <br><br>

        <strong>2. วัตถุประสงค์การใช้งาน</strong><br>
        เบราว์เซอร์ LocalStorage ถูกใช้อย่างเคร่งครัดเพื่อบันทึกการตั้งค่า เช่น: <br>
        - การตั้งค่าภาษา <br>
        - การกำหนดค่าอินเทอร์เฟซผู้ใช้ (เช่น การตั้งค่าเค้าโครงหรือธีม) <br>
        - แคชแอปพลิเคชันชั่วคราว <br><br>

        <strong>3. ไม่มีการติดตาม</strong><br>
        คุกกี้และที่เก็บข้อมูลในเครื่องไม่ได้ใช้เพื่อการโฆษณาหรือการติดตามบุคคลที่สาม ข้อมูลที่เก็บไว้ทั้งหมดมีไว้สำหรับฟังก์ชันการทำงานหลักของแพลตฟอร์มเท่านั้น <br><br>

        <strong>4. คอนโทรล</strong><br>
        ข้อมูลเบราว์เซอร์สามารถล้างได้ตลอดเวลาผ่านการตั้งค่าเบราว์เซอร์ ซึ่งจะรีเซ็ตการกำหนดค่าในเครื่อง
    `,
    cookie_consent_text: "เราใช้คุกกี้พื้นฐานเพื่อให้แน่ใจว่าเว็บไซต์ทำงานได้อย่างถูกต้อง เช่น ทำให้เซสชันของคุณใช้งานได้ บันทึกการตั้งค่าภาษาของคุณ และการกำหนดค่าแบบกำหนดเองอื่นๆ",
    read_policy: "อ่านนโยบายคุกกี้",
    support_title: "ติดต่อฝ่ายสนับสนุน",
    support_subject_label: "เรื่อง",
    support_message_label: "ข้อความ",
    support_submit_button: "ส่งข้อความ",
    support_hint: "หมายเหตุ: นี่จะเป็นการเปิดแอปพลิเคชันอีเมลเริ่มต้นของคุณเพื่อส่งข้อความ",
    support_success_msg: "กำลังเปิดแอปอีเมลของคุณ...",
    support_error_msg: "ไม่สามารถส่งข้อความได้ โปรดลองอีกครั้งในภายหลัง",
    explorer_title: "นักสำรวจ",
    history_title: "ประวัติศาสตร์",
    animation_title: "แอนิเมชั่น",
    config_title: "การกำหนดค่า",
    tool_mouse: "เลือก (Ctrl+M)",
    tool_brush: "แปรง (Ctrl+B)",
    tool_brush_mode: "สลับโหมด (ทึบ/เคลียร์)",
    tool_eraser: "ยางลบ (Ctrl+E)",
    tool_brush_size: "ปรับขนาดแปรง",
    tool_bucket: "เติม (Ctrl+F)",
    tool_eyedropper: "ยาหยอดตา",
    tool_grid: "ตาราง (Ctrl+Shift+B)",
    tool_rotate: "หมุน (Ctrl+Shift+R)",
    tool_flip_h: "พลิก H (Ctrl+Shift+H)",
    tool_flip_v: "พลิก V (Ctrl+Shift+V)",
    tool_transpose: "ย้าย (Ctrl+Shift+T)",
    label_width: "ความกว้าง",
    label_height: "ความสูง",
    label_frames: "จำนวนเฟรม",
    label_animation: "แอนิเมชั่นสไตล์",
    label_background_color: "สีพื้นหลัง",
    label_interval: "ช่วงเวลา",
    tool_anim_config: "การกำหนดค่าแอนิเมชั่น",
    label_new_width: "ความกว้างใหม่",
    label_new_height: "ความสูงใหม่",
    label_apply: "นำมาใช้",
    label_colors: "สี",
    label_size: "ขนาด",
    label_tolerance: "ความอดทน",
    val_horizontal: "แนวนอน",
    val_vertical: "แนวตั้ง",
    val_sequence: "ลำดับ",
    val_bounce: "เด้ง",
    val_random: "สุ่ม",
    val_solid: "แข็ง",
    val_clear: "ชัดเจน",
    action_add_sheet: "แผ่นงานใหม่",
    action_import: "นำเข้า",
    action_export: "ส่งออก",
    action_sort_projects: "เรียงลำดับ",
    sort_date_old: "เก่าแก่ที่สุดก่อน",
    sort_date_new: "ใหม่ล่าสุดก่อน",
    sort_name_az: "ชื่อ (ก-ฮ)",
    sort_name_za: "ชื่อ (ศ-ก)",
    action_new_sprite: "สไปรท์ใหม่",
    action_new_project: "โครงการใหม่",
    modal_save_all_title: "บันทึกการเปลี่ยนแปลงทั้งหมด",
    modal_save_all_desc: "เลือกสินทรัพย์ที่จะบันทึก:",
    modal_save_selected: "บันทึกที่เลือก",
    action_saved: "บันทึกแล้ว",
    modal_create_sprite_title: "สร้างสไปรท์ใหม่",
    modal_create_project_title: "สร้างโครงการใหม่",
    modal_add_sheet_title: "เพิ่มแผ่นงานใหม่",
    modal_rename_sheet_title: "เปลี่ยนชื่อแผ่นงาน",
    modal_rename_sprite_title: "เปลี่ยนชื่อสไปรท์",
    modal_delete_sprite_title: "ลบสไปรท์",
    modal_delete_project_title: "ลบโครงการ",
    modal_delete_sheet_title: "ลบแผ่นงาน",
    placeholder_sprite_name: "ชื่อ",
    placeholder_project_name: "ชื่อ",
    placeholder_sheet_name: "ชื่อ",
    placeholder_new_name: "ชื่อใหม่",
    action_create: "สร้าง",
    action_add: "เพิ่ม",
    action_rename: "เปลี่ยนชื่อ",
    action_duplicate: "ทำซ้ำ",
    action_delete: "ลบ",
    action_cancel: "ยกเลิก",
    confirm_delete_sprite: "คุณแน่ใจหรือไม่ว่าต้องการลบสไปรท์นี้",
    confirm_delete_project: "คุณแน่ใจหรือไม่ว่าต้องการลบโครงการนี้ สไปรท์ทั้งหมดจะถูกลบออก",
    confirm_delete_sheet: "คุณแน่ใจหรือไม่ว่าต้องการลบแผ่นงานนี้",
    err_select_sprite: "โปรดเลือกสไปรท์ก่อน",
    err_select_project: "โปรดเลือกโครงการก่อน",
    err_name_empty: "ชื่อไม่สามารถเว้นว่างได้",
    err_sprite_exists: "มีสไปรท์ชื่อนั้นอยู่แล้ว",
    err_project_exists: "มีโครงการชื่อนั้นอยู่แล้ว",
    err_no_content: "ไม่มีเนื้อหาที่จะบันทึก",
    err_no_changes: "ไม่มีการเปลี่ยนแปลงที่จะบันทึก",
    err_delete_last_sheet: "ไม่สามารถลบแผ่นงานสุดท้ายได้",
    err_extract_frames: "ไม่สามารถแยกเฟรมใดๆ ได้",
    err_indexeddb: "บันทึกในเครื่องไม่สำเร็จ เบราว์เซอร์ของคุณอาจไม่รองรับ IndexedDB",
    msg_upload_success: "อัปโหลดสำเร็จ: {0}",
    msg_upload_failed: "การอัปโหลดล้มเหลว: {0}",
    msg_save_success: "บันทึกสำเร็จ",
    msg_saving: "ประหยัด...",
    msg_multi_save_result: "บันทึกเนื้อหาแล้ว {0} รายการ {1} ความล้มเหลว",
    menu_title: "เมนู",
    menu_save: "บันทึก",
    menu_save_all: "บันทึกทั้งหมด",
    menu_support: "ติดต่อฝ่ายสนับสนุน",
    label_local_storage: "ที่เก็บข้อมูลท้องถิ่น",
    label_sign_in: "เข้าสู่ระบบ",
    modal_export_title: "ส่งออกสไปรท์",
    label_filename: "ชื่อไฟล์",
    label_format: "รูปแบบ",
    action_export_confirm: "ส่งออก",
};

export default translations;
